var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hiv-quiz',{attrs:{"question":"A person can get HIV from having oral sex.","answer":true}})}
var staticRenderFns = []

export { render, staticRenderFns }